export default {
  'app.console.nodata': '暂无数据',
  'app.console.recents': '近日访问',
  'app.console.recents.nodata': '暂无数据，去开通业务',
  'app.console.channel': '待开通服务',
  'app.console.channel.active': '已开通服务',
  'app.console.channel.activateService': '开通服务',
  'app.console.channel.learnMore': '了解详情',
  'app.console.channel.sendNum': '发送数量',
  'app.console.channel.targetNum': '有效目标',
  'app.console.channel.deliveredNum': '送达数量',
  'app.console.channel.clickNum': '点击数量',
  'app.console.channel.readNum': '已读数量',
  'app.console.channel.sendNumRate': '实发率',
  'app.console.channel.deliveredNumRate': '送达率',
  'app.console.channel.clickNumRate': '点击率',
  'app.console.channel.readNumRate': '已读率',
  'app.console.channel.title1': '近7日趋势',
  'app.console.channel.title2': '近7日转化',
  'app.console.channel.sendOut': '发送消息',
  'app.console.channel.start': '开始使用',
  'app.console.channel.message.activated': '已启用',
  'app.console.channel.message.apppush':
    '3分钟快速集成SDK，实现智能化精准推送，有效提升用戶活跃和留存',
  'app.console.channel.message.email':
    '提供高效稳定的邮件发送 API，支持配置独立 IP、BIMI 认证，并通过实时精准的数据回执，优化发送策略以提高送达率。',
  'app.console.channel.message.sms': '短信触达能力覆盖全球，帮助企业快速实现全球短信触达',
  'app.console.channel.message.whatsapp':
    '通过WhatsApp Business API，与超过20亿的全球用戶建立更加紧密和自然的联系',
  'app.console.channel.message.OTP':
    'EngageLab OTP 提供一次性密码的生成与校验服务，支持 WhatsApp、SMS、Voice、Email 多通道发送，保证您的送达与转化。',
  'app.console.channel.message.webpush':
    '不再需要依賴移动APP，您可以随时向网站订阅者推送营销消息和服务通知，提升用戶活跃和转化',
  'app.console.channel.message.edm':
    ' 一键安装无需开发，让你的店铺轻松开展电子邮件营销，利用邮件自动化功能推动客户参与购买，增加收入',
  'app.console.channel.message.ma':
    '营销自动化服务支持管理用户数据，构建用户旅程，使用多渠道触达您的用户，为用户提供响应迅速且个性化的体验',
  'app.console.channel.message.captcha':
    '行为式验证码，更智能地解决机器脚本程序自动化攻击带来的业务损失与安全隐患。',
  'app.console.channel.message.livedesk': 'AI 驱动的客户服务平台，完美处理 90% 的客户问题。',
  'app.console.channel.flag.email': '新数据节点',
  'app.console.doc': 'REST API 文档指南',
  'app.console.doc.apppush': 'AppPush 文档指南',
  'app.console.doc.email': 'Email 文档指南',
  'app.console.doc.sms': 'SMS 文档指南',
  'app.console.doc.newsms': 'SMS 文档指南',
  'app.console.doc.whatsapp': 'WhatsApp  文档指南',
  'app.console.doc.webpush': 'WebPush  文档指南',
  'app.console.doc.edm': 'EDM  文档指南',
  'app.console.doc.otp': 'OTP 文档指南',
  'app.console.doc.ma': 'Marketing Automation 文档指南',
  'app.console.doc.captcha': 'CAPTCHA 文档指南',
  'app.console.doc.livedesk': 'LiveDesk 文档指南',
  'app.console.manage': '管理',
  'app.console.manage.orders': '订单&账单',
  'app.console.manage.pending': '待支付订单',
  'app.console.manage.supplementary': '待补缴账单',
  'app.console.manage.notification': '服务提醒',
  'app.console.manage.faq': '常见问题',
  'app.console.manage.download': '下载',
  'app.console.channel.verifiedRate': '回填率',
  'app.console.channel.verifiedNum': '回填数量',
  'app.console.channel.select.all': '全部',
};
